import {cn} from 'app/lib'
import React, {ButtonHTMLAttributes, FC, ReactNode} from 'react'

const baseClasses = {
	primary: 'bg-primary text-onPrimary py-2 px-4 rounded hover:bg-primary-hover',
	secondary:
		'bg-secondary text-onSecondary py-2 px-4 rounded hover:bg-secondary-hover',
	danger: 'bg-danger text-white py-2 px-4 rounded hover:bg-danger-hover',
	success: 'bg-success text-white py-2 px-4 rounded hover:bg-success-hover',
	outline:
		'border border-tertiary text-tertiary py-2 px-4 rounded hover:bg-capGoldLight',
	link: 'text-capGold underline hover:text-capGoldLight',
}

const TwButton: FC<{
	variant?: keyof typeof baseClasses
	children: ReactNode
	className?: string
	disabled?: boolean
	type?: 'button' | 'submit' | 'reset'
	onClick?: () => void
}> &
	ButtonHTMLAttributes<HTMLButtonElement> = ({
	variant = 'primary',
	children,
	className,
	onClick,
	disabled,
	type = 'button',
	...props
}) => {
	return (
		<button
			className={cn(
				'cursor-pointer text-base transition-colors duration-200 focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
				baseClasses[variant],
				className
			)}
			disabled={disabled}
			onClick={onClick}
			type={type}
			{...props}
		>
			{children}
		</button>
	)
}

export default TwButton
